import saveAs from 'file-saver';

export default function exportExcelFileFrom(data:any[], headers: string[] | null = null, fileName: string = "export") : void {
    import('xlsx').then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(data);

        if (headers)
            xlsx.utils.sheet_add_aoa(worksheet, [ headers ], { origin: "A1" });
        
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

        saveAsExcelFile(excelBuffer, fileName);
    });
}

const saveAsExcelFile = (buffer: any, fileName: any): void => {
    // import('file-saver').then((module) => {
        // if (module && module.default) {
            const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const EXCEL_EXTENSION = '.xlsx';
            const dataFile = new Blob([buffer], {
                type: EXCEL_TYPE,
            });

            saveAs(dataFile, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`);
        // }
    // });
}